import React from 'react';
import Strapi from '../../services/strapi';
import { useNotification } from '../../contexts/Notification';
import Confirm from '../../atoms/Confirm';

interface ArticleRemoveInterface {
    id: number,
    collection: string,
    onRemove?: () => void, 
}

const ArticleRemove = (props: ArticleRemoveInterface) => {
    const notification = useNotification();

    return <Confirm
        message="Confirmer la supression"
        action={() => {
            return Strapi.delete(`${props.collection}s/${props.id}`).then((r) => {
                notification.notify("Removed");
                if (props.onRemove) {
                    props.onRemove();
                }
            }).catch(e => {
                notification.notify("Fail to remove", "error");
            })
        }}
        trigger="Supprimer"
    />
}

export default ArticleRemove;